import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

import {
	DEFAULT_LANGUAGE,
	type Language,
	SUPPORTED_LANGUAGES,
} from "./constant";

function isSupported(lng: string): lng is Language {
	return Object.values(SUPPORTED_LANGUAGES).includes(lng as Language);
}

function getPersistedLanguage(): Language {
	try {
		const stored = localStorage.getItem("marinavalue-language");
		if (stored) {
			const parsed = JSON.parse(stored);
			const language = parsed?.state?.language;
			if (language === "en" || language === "ko" || language === "ja") {
				return language;
			}
		}
	} catch (error) {
		console.warn("Failed to read persisted language:", error);
	}
	return DEFAULT_LANGUAGE;
}

i18n
	.use(
		resourcesToBackend(async (lng: string, ns: string) => {
			if (!isSupported(lng)) {
				throw new Error(`Unsupported language: ${lng}`);
			}
			if (ns !== "translation") {
				throw new Error(`Unsupported namespace: ${ns}`);
			}
			switch (lng) {
				case "en":
					return (await import("./locales/en-translation.json")).default;
				case "ko":
					return (await import("./locales/ko-translation.json")).default;
				case "ja":
					return (await import("./locales/ja-translation.json")).default;
				default: {
					const _exhaustive: never = lng;
					throw new Error(`Unhandled language: ${_exhaustive}`);
				}
			}
		}),
	)
	.use(initReactI18next)
	.init({
		lng: getPersistedLanguage(),
		fallbackLng: DEFAULT_LANGUAGE,
		defaultNS: "translation",
		ns: ["translation"],
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
